import React from 'react';

import { StepListProps } from './StepList.types';

import styles from './StepList.module.scss';

export const StepList = ({ align = 'top', steps = [] }: StepListProps) => {
  if (!steps.length) {
    return null;
  }

  return <ol className={styles.stepList} data-alignment={align}>
    {steps.map(({ content }, index) => (
      <li key={`steps-${index}`} className={styles.step}>
        {content}
      </li>
    ))}
  </ol>;
};
